import { Component } from "../../../components/base/Component";
import { ICfa } from "../../../models/ICfa";
import { ComponentFactory } from "../../../services/ComponentFactory";

export class ModalVideo extends Component {
	constructor(_element: HTMLElement, _app: ICfa) {
		super(_element, _app);

		$(`#${this.buttonId}`).magnificPopup({
			items: {
				src: this.iframeLink || "",
				type: "iframe"
			}
		});
	}

	get iframeLink(): string {
		return this._element.dataset.iframe || "";
	}

	get buttonId(): string {
		return this._element.dataset.buttonId || "";
	}
}

ComponentFactory.registerComponent("ModalVideo", ModalVideo);
